import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import React from "react";
import { css } from "styled-components";

interface CustomWidgetStyles {}

const styles: CustomWidgetStyles = {};

const AccessorialsFiltersContainer: React.FC<WidgetProps> = ({ id }) => {
    return (
        <GridContainer
            css={css`
                margin-bottom: 1rem;
            `}
        >
            <GridItem width={[12, 12, 6, 6, 6]}>
                <Zone contentId={id} zoneName="SearchFilter" />
            </GridItem>
            <GridItem width={[12, 12, 6, 6, 6]}>
                <GridContainer>
                    <GridItem
                        width={6}
                        css={css`
                            align-items: center;
                            justify-content: center;
                        `}
                    >
                        <StyledWrapper
                            css={css`
                                display: flex;
                                justify-content: center;
                                width: 100%;
                                max-width: 100px;
                            `}
                        >
                            <Zone contentId={id} zoneName="ImportAccessorialsContainer" />
                            <Zone contentId={id} zoneName="ExportAccessorialsContainer" />
                        </StyledWrapper>
                    </GridItem>
                    <GridItem width={6}>
                        <Zone contentId={id} zoneName="AddAccessorialsContainer" />
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};

const accessorialsFiltersContainer: WidgetModule = {
    component: AccessorialsFiltersContainer,
    definition: {
        group: "Basic",
    },
};

export default accessorialsFiltersContainer;
